import {
	AppCacheActions,
	AppCacheState,
	CacheKey,
	useAppCacheStore,
} from "@/common/stores/persistingStores/app";
import {
	CurrentInteractionActions,
	useCurrentInteractionStore,
} from "@/common/stores/nonpersistingStores/currentInteraction";
import {
	NavigationActions,
	useNavigationStore,
} from "@/common/stores/persistingStores/navigation";
import { useQueuesStore, QueuesState } from "@/common/stores/nonpersistingStores/queues";
import { useResponsiveBreakpoints } from "@/hooks/responsive";
import { InteractionDto } from "@/repository/models";
import { previewStarted, previewStopped } from "@/repository/queryFns";
import { useCallback } from "react";

export const useEmailInteractionPreview = () => {
	const appStoreCache = useAppCacheStore((state: AppCacheState) => state.cache);
	const appStoreActions = useAppCacheStore((state: AppCacheActions) => state);

	const currentInteractionActions = useCurrentInteractionStore(
		(actions: CurrentInteractionActions) => actions
	);

	const queues = useQueuesStore((state: QueuesState) => state.queues);

	const setIsMobileDetailViewMode = useNavigationStore(
		(actions: NavigationActions) => actions.setIsMobileDetailViewMode
	);

	const { isMobile } = useResponsiveBreakpoints();

	const startEmailPreview = useCallback(
		(interaction: InteractionDto) => {
			appStoreActions.setCache(CacheKey.PreviewInteractionId, interaction.id);
			currentInteractionActions.showPreview({
				...interaction,
				isPickupEnabled:
					queues.find((x) => x.id == interaction.queueId)?.isPickupEnabled ??
					false,
			});

			if (isMobile) {
				setIsMobileDetailViewMode(true);
			}

			previewStarted(interaction.id).catch(() => {
				console.log("previewStarted webhook error");
			});
		},
		[appStoreActions, currentInteractionActions, queues]
	);

	const hideEmailPreview = useCallback(() => {
		const previewInteractionId = appStoreCache[CacheKey.PreviewInteractionId];

		if (previewInteractionId) {
			appStoreActions.removeCaches([CacheKey.PreviewInteractionId]);
			currentInteractionActions.hidePreview();

			previewStopped(previewInteractionId).catch(() => {
				console.log("previewStopped webhook error");
			});
		}
	}, [appStoreActions, currentInteractionActions]);

	return { showEmailPreview: startEmailPreview, hideEmailPreview };
};
